"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
var wikom_data_1 = require("@wikom/wikom-data");
var actionLog = function (state, action) {
    if (state === void 0) { state = []; }
    return (action.type !== wikom_data_1.actionTypes.SET_USER ? __spreadArray(__spreadArray([], state, true), [action], false) : state);
};
exports["default"] = actionLog;
